var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CzSegments',{staticClass:"programProgress",attrs:{"done":_vm.value,"total":_vm.max,"label":_vm.label}})}
var staticRenderFns = []

export { render, staticRenderFns }